<template>
  <div class="overlay" v-bind:class="{ 'overlay--active': active }"></div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.component('Overlay', {
    props: {
      active: Boolean,
    },
  });
</script>